import { IonCol, IonGrid, IonRow } from '@ionic/react'
import { ResidenceCard } from 'components'
import React from 'react'
import { IResidenceCardGridProps } from './residence-card-grid-props.interface'
import './residence-card-grid.scss'
import { Swiper, SwiperSlide } from 'swiper/react'
import { useTranslation } from 'react-i18next'
import { motion } from 'framer-motion'
import { BREAKPOINTS } from 'interfaces'

const ResidenceCardGrid: React.FC<IResidenceCardGridProps> = ({
  residences,
  header,
  footer,
  searchParams,
  loadingComponent,
  emptyNode,
  mobileAsSlider = false,
  openLinkInNewPage,
}) => {
  const { t } = useTranslation()

  return (
    <>
      <IonGrid className={'edisu-residences-grid' + (mobileAsSlider ? ' mobile-as-slider' : '')}>
        {header && (
          <IonRow>
            <IonCol size="12" className="residence-grid-header residence-grid-col title">
              {header}
            </IonCol>
          </IonRow>
        )}
        <IonRow>
          {loadingComponent ? (
            <IonCol size="12">{loadingComponent}</IonCol>
          ) : (
            residences &&
            (residences.length === 0 ? (
              emptyNode || <p>{t('empty_results_residences')}</p>
            ) : (
              <>
                {residences.map((r) => (
                  <IonCol
                    size="12"
                    sizeMd="6"
                    sizeLg="3"
                    className={'residence-grid-col' + (mobileAsSlider ? ' ion-hide-lg-down' : '')}
                    key={r.residence.id}
                  >
                    <motion.div
                      key={r.residence.id}
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      exit={{ opacity: 0 }}
                      transition={{ duration: 0.7 }}
                      className="motion-div"
                    >
                      <ResidenceCard residence={r.residence} searchParams={searchParams} openLinkInNewPage={openLinkInNewPage} />
                    </motion.div>
                  </IonCol>
                ))}

                {mobileAsSlider && (
                  <IonCol size="12" className="ion-hide-lg-up ion-no-padding">
                    <Swiper
                      slidesPerView={1}
                      slidesPerGroup={1}
                      spaceBetween={20}
                      breakpoints={{
                        [BREAKPOINTS.md]: {
                          slidesPerView: 2,
                        },
                      }}
                    >
                      {residences.map((r) => (
                        <SwiperSlide key={r.residence.id}>
                          <ResidenceCard residence={r.residence} searchParams={searchParams} openLinkInNewPage={openLinkInNewPage} />
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  </IonCol>
                )}
              </>
            ))
          )}
        </IonRow>
      </IonGrid>
      {footer}
    </>
  )
}

export default ResidenceCardGrid
